<template>
  <div>
    <el-upload drag action="" :before-upload="beforeUpload" :show-file-list="false">
      <div v-if="!val">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或拖拽上传图片</div>
      </div>
      <img v-else style="height: 100%;" :src="val" alt="">
    </el-upload>
  </div>
</template>

<script>
import { upload } from "@/api/upload";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      val: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.val = val;
      },
      immediate: true,
    },
  },
  methods: {
    beforeUpload(file) {
      const [type] = file.type.split("/");
      if (type != "image") {
        this.$message.warning("请上传图片文件");
        return;
      }
      upload(file).then(({ code, message, data }) => {
        if (code == 200) {
          this.val = data;
          this.$emit("input", this.val);
          this.$emit("change", this.val);
        } else {
          this.$message.error(message);
        }
      });
      return false;
    },
  },
};
</script>

<style></style>